export const changeTitle = text => {
	document.querySelector("title").innerText = text;
};
